// Module
var code = "<a class=\"edes-download-button\" ng-click=\"vm.downloadEvidenceSummary()\"> <icon-pdf></icon-pdf> Evidence Summary </a> ";
// Exports
module.exports = code;